import React from 'react';
import HeroBanner from '../components/HeroBanner';
import ServicesGrid from '../components/ServicesGrid';
import WhySection from '../components/WhySection';
import TeamAndCTA from '../components/TeamAndCTA';

export default function Home() {
  return (
    <div className="page-enter">
      <HeroBanner />
      <ServicesGrid />
      <WhySection />
      <TeamAndCTA />
    </div>
  );
}
